/**
 * /orders
 *
 * The queue workbench. A4 owns the router; `app/ordersAdapter.tsx` wraps this component
 * into the tree, so this file exports a plain component rather than a `Route`. Keeping the
 * router in one place is A4's call and this follows it.
 *
 * The screen reads its own filters out of the URL, so this passes nothing but the order id
 * the path carries and the way to change it.
 */
import { OrdersPage } from '@/features/orders';

export interface OrdersRouteProps {
  /** Present when the URL is /orders/:orderId. The drawer opens over the list. */
  orderId?: number | null;
  onOrderIdChange?: (orderId: number | null) => void;
}

export function OrdersRoute({ orderId = null, onOrderIdChange }: OrdersRouteProps) {
  return (
    <OrdersPage orderId={orderId} {...(onOrderIdChange ? { onOpenOrder: onOrderIdChange } : {})} />
  );
}

export default OrdersRoute;
